export default ['Resty', Resty => Resty('active_directories')];
